import { type ReactNode, useCallback } from 'react'
import cx from 'classnames'
import { Icon } from '@/components/Icon'
import styles from './RadioGroup.module.css'
import { RawButton } from '@/components/Button'

interface RadioGroupProps {
  children?: ReactNode
}

/**
 * A group of radio items.
 */
export function RadioGroup({ children }: RadioGroupProps) {
  return <div className={styles.radioGroup}>{children}</div>
}

interface RadioItemProps {
  children?: ReactNode
  selected: boolean
  onChange: (newValue: boolean) => unknown
  testId?: string
}

/**
 * A radio item in a radio group.
 */
export function RadioItem({
  children,
  selected,
  testId,
  onChange,
}: RadioItemProps) {
  const change = useCallback(() => {
    onChange(!selected)
  }, [selected, onChange])

  return (
    <RawButton
      role="radio"
      aria-checked={selected}
      className={cx(styles.radioItem, selected && styles.selected)}
      testId={testId}
      onPress={change}
    >
      <div className={cx(styles.selectedRadioIcon, selected && styles.pop)}>
        <Icon
          auto
          color="var(--theme-base)"
          name={selected ? 'radio-selected' : 'radio'}
        />
      </div>
      <div className={styles.radioItemContent}>{children}</div>
    </RawButton>
  )
}
